<script setup lang="ts">
import { Gauge } from 'lucide-vue-next'
import { storeToRefs } from 'pinia'
import { useExecutionStore } from '@/stores/domain'

const executionStore = useExecutionStore()
const { slots } = storeToRefs(executionStore)
</script>

<template>
  <RouterLink class="slot-pill" to="/app/executions" title="Open execution scheduler">
    <span class="slot-pill__icon"><Gauge :size="15" /></span>
    <span
      ><strong>{{ slots.active }}</strong> of {{ slots.entitled }} active</span
    >
    <span class="slot-pill__preview">Live</span>
  </RouterLink>
</template>
